<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Apertura Siniestro
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-md>
                <v-row dense>
                    <v-col cols="12">
                        <ModalAperturaSiniestroComponent :open="obModal.open"
                                                         :listGeneral="listGeneral"
                                                         :obModal="obModal"
                                                         :parametros="parametros"
                        />
                    </v-col>
                </v-row>

                <v-form ref="form">
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-autocomplete label="Aseguradora *" color="textbox" v-model="obSearch.idAseguradora"
                                    :items="listGeneral.listAseguradora" item-text="aseguradora" item-value="idAseguradora" 
                                    outlined dense @change="onListarPoliza" :rules="requeridoRegla" />   
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete label="Póliza *" color="textbox" v-model="obSearch.idPoliza"
                                    :items="listGeneral.listPoliza" item-text="poliza" item-value="id_poliza" 
                                    outlined dense :rules="requeridoRegla" />   
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete label="Estado Registro *" color="textbox" v-model="obSearch.estadoRegistro"
                                    :items="listGeneral.listEstadoRegistro" outlined dense :rules="requeridoRegla" />   
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="N° Certificado " color="textbox" v-model="obSearch.idCertificado" dense
                                    outlined :rules="_.size(obSearch.idCertificado) > 0 ? numeroRegla : []" />
                        </v-col>
                        <v-col cols="12" sm="4"/>
                        <v-col cols="12" sm="4" class="text-right">
                            <v-tooltip right color="primary">
                                <template v-slot:activator="{ on }">
                                    <v-btn outlined color="primary" @click="onListar" v-on="on" :disabled="disabled">
                                        Buscar<v-icon>search</v-icon>
                                    </v-btn>
                                </template>
                                <span>Buscar</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>   
                </v-form>

                <v-row dense>
                    <v-col cols="12" sm="6"/>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-data-table :search="obSearch.search" :headers="listGeneral.listCabecera"
                            :items="listGeneral.listDetalle" class="elevation-3">
                            
                            <template v-slot:item.valorReserva="{ item }">
                                {{ formatNumber(item.valorReserva) }}
                            </template>

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="editar(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name:'AperturaSiniestroView',
        components:{
            ModalAperturaSiniestroComponent: () => import('@/components/siniestro/ModalAperturaSiniestroComponent.vue')
        },
        data: () => ({
            obSearch:{
                search:'',
                idAseguradora:null,
                idPoliza:null,
                idCertificado:null,
                idEstado:null,
                estadoRegistro:'S'
            },
            obModal:{
                open:false,
                titulo:'Registrar Apertura de Siniestro'
            },
            disabled:false,
            listGeneral:{},
            parametros:{}
        }),
        created(){
            var error = 'E';
            console.info(this.isMovil)
            axios.post(`${BASE_URI}administrador/siniestro/cargaGeneralAperturaSiniestro`)
                 .then((r)=>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0){ error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.obSearch.idAseguradora = this.listGeneral.listAseguradora[0].idAseguradora;
                        this.obSearch.idEstado = _.toString(this.parametros.idEstadoDefault);

                        return this.onListarPoliza('L');
                 })
                 .then((r)=>{
                     if(_.size(_.get(r,['data','data'],[])) > 0)
                        this.obSearch.idPoliza = r.data.data[0].id_poliza;
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,error);
                 });
        },
        methods:{
            onListarPoliza(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var o = { opcion:'LISTAR',idAseguradora: this.obSearch.idAseguradora };
                    this.listGeneral.listPoliza = [];

                    return axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                                .then((r)=>{
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if(_.size(_.get(r,['data','data'],[])) == 0){ error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                        this.listGeneral.listPoliza = r.data.data;

                                        return r;
                                })
                                .catch((e)=>{
                                    mensajesAlerta(e,error);
                                    return e;
                                });
                }
            },
            onListar(event){
                if(!_.isUndefined(event)){
                    try {
                        if(!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                            var error = 'E';
                            var o = { 
                                        opcion:'L_SINIESTRO_NOTIFICADO',
                                        obSiniestro:_.pick(this.obSearch,['idPoliza','estadoRegistro'])
                                    };
                            this.listGeneral.listDetalle = [];
            
                            axios.post(`${BASE_URI}administrador/siniestro/listar`,o)
                                .then((r)=>{
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if(_.size(_.get(r,['data','data'],[])) == 0){ error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                        this.listGeneral.listDetalle = r.data.data;
                                })
                                .catch((e)=>{
                                    mensajesAlerta(e,error);
                                });
                    } catch (e) {
                        mensajesAlerta(e,'I');
                    }
                }
            },
            editar(v){
                v.valorReserva = Number(v.valorReserva).toFixed(2);
                this.$set(this,'obModal',_.merge({},this.obModal,v,{open:true}));
            },
            close(band){
                this.obModal = {
                    open:false,
                    titulo:'Registrar Apertura de Siniestro'
                }

                if(band)
                    this.onListar('L');
            }
        },
        provide(){
            return{
                close:this.close
            }
        }
    }
</script>
